export const STALE_TIME = 5 * 60 * 1000;
export const STALE_TIME_MEDIUM = 1 * 60 * 1000;
export const STALE_TIME_VERY_LARGE = 30 * 60 * 1000;
